import { render, staticRenderFns } from "./ModelosCatalogo.vue?vue&type=template&id=43772e0c&scoped=true"
import script from "./ModelosCatalogo.vue?vue&type=script&lang=js"
export * from "./ModelosCatalogo.vue?vue&type=script&lang=js"
import style0 from "./ModelosCatalogo.vue?vue&type=style&index=0&id=43772e0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43772e0c",
  null
  
)

export default component.exports